import React from 'react';
import PropTypes from 'prop-types';

import {Box, TextField, Typography, Stack} from 'views/components';
import {translate} from 'views/module';

const RadioInput = (props) => {
  const {
    questionData,
    options,
    value,
    otherText,
    onSelect,
    onOtherTextChange,
  } = props;

  return (
    <Box>
      {
        questionData.helpText &&
        <Typography gutterBottom>
          {questionData.helpText}
        </Typography>
      }
      <Stack spacing='8px'>
        {
          options.map((option) => (
            <Box
              key={option.value}
              sx={{
                '& :hover': {
                  'borderColor': '#DA7955',
                },
              }}
            >
              <Box
                onClick={() => onSelect(option)}
                sx={{
                  'paddingX': '20px',
                  'paddingY': '16px',
                  'borderRadius': '12px',
                  'border': '1px solid',
                  'backgroundColor': value === option.value ? '#DA795514' : 'transparent',
                  'borderColor': value === option.value ? '#DA7955' : '#DED8D7',
                  'cursor': 'pointer',
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '150%',
                    textAlign: 'center',
                  }}
                >
                  {option.label}
                </Typography>
              </Box>
              {
                option.isOther && value === option.value &&
                <TextField
                  placeholder={translate('form.Inputs.OtherPlaceholder')}
                  value={otherText}
                  onChange={(value) => onOtherTextChange(value)}
                  fullWidth
                  sx={{marginTop: '12px'}}
                  slotProps={{
                    input: {
                      sx: {
                        'borderRadius': '12px',
                        'fontWeight': 400,
                        'fontSize': '16px',
                        'lineHeight': '150%',
                      },
                    },
                  }}
                />
              }
            </Box>
          ))
        }
      </Stack>
    </Box>
  );
};

RadioInput.propTypes = {
  questionData: PropTypes.shape({
    helpText: PropTypes.string,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    label: PropTypes.string.isRequired,
    isOther: PropTypes.bool.isRequired,
  })).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  otherText: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onOtherTextChange: PropTypes.func.isRequired,
};

export default RadioInput;
